import React from 'react';
import { Button, PageHeader } from 'antd';
import { withRouter } from 'react-router';
import { PUBLIC_PATHS } from '../../utils/constant';
import './Header.less';
import { formatMessage } from '../../utils/text';

const JOINPLACE_URL = 'https://www.joinplace.com.br';

function Header({ children, footer }) {
  const openJoinplace = () => window.open(JOINPLACE_URL, '_blank');

  return (
    <div className="header-wrapper">
      <PageHeader
        className="header-fixed"
        key="pageheader"
        title={
          <div className="jp-header-bar">
            <div className="jp-header-bar__hero" aria-hidden>
              <img
                className="jp-header-bar__hero-img"
                src={PUBLIC_PATHS.images.headerBlueprintBanner}
                alt=""
                decoding="async"
              />
            </div>
            <div className="jp-header-bar__inner">
              <button
                type="button"
                className="jp-header-brand"
                onClick={openJoinplace}
                aria-label="joinplace">
                <span className="jp-header-brand__row">
                  <img
                    className="jp-header-brand__logo"
                    src={PUBLIC_PATHS.images.joinplaceLogo}
                    alt=""
                    decoding="async"
                  />
                  <span className="jp-header-brand__name">Joinplace</span>
                </span>
                <p className="jp-header-brand__tagline">
                  {formatMessage('projectItem.headerTagline')}
                </p>
              </button>
              <Button
                type="default"
                className="jp-header-cta"
                onClick={openJoinplace}>
                {formatMessage('projectItem.ctaJoinplace')}
              </Button>
            </div>
          </div>
        }
        footer={footer()}>
        {children}
      </PageHeader>
    </div>
  );
}

export default withRouter(Header);
